import { defineComponent as _defineComponent } from 'vue'
import { provide, readonly, ref } from "vue"
import FinalStep from "@/modules/Users/Invitation/shared/FinalStep.vue"
import useRouter from "@/router/useRouter"


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupSuccess',
  setup(__props) {

const url = new URL(window.location.href)
const searchParams = new URLSearchParams(url.search)

if (!searchParams.has("subscription_id")) {
  const { router } = useRouter()

  router.push("/signup/ahead_business")
}

const form = ref({})

provide("productType", readonly({}))
provide("form", readonly(form))

return { __sfc: true,url, searchParams, form, FinalStep }
}

})